import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import * as _ from 'lodash';
import { AllotmentConfirmationComponent } from 'src/app/courses/assignment-status/allotment-confirmation/allotment-confirmation.component';
import { UtilityService } from 'src/app/services/utility.service';
import differenceBy from 'lodash/differenceBy'
import { JobService } from 'src/app/services/jobs/job.service';
import { UserRoleService } from 'src/app/services/user-role.service';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-attendance-day',
  templateUrl: './attendance-day.component.html',
  styleUrls: ['./attendance-day.component.scss']
})
export class AttendanceDayComponent implements OnInit {
  user: any;
  currentUser: any;
  hoverIndex: any;
  noDataMessage: any = { data: "Course is of zero days." };
  count: any;
  jobData
  attendanceStatus = ["AM", "PM"]
  courseMetaId
  isAdmin: boolean = false
  isTrainer: boolean = false;
  isIQA: boolean = false;
  isStaff: boolean = false;
  @Input('attendanceData') attendance;
  @Input('clearData') clearData;
  @Input('selectedLearner') selectedLearner;
  @Input('hoverIndex') hoverIndexValue;
  @Input('countIndex') countIndex;
  @Input('courseMeta') selectedCourseMetaId;
  @Input('courseId') courseId;
  @Input('singleJob') singleJob
  @Output() logUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() dateUpdate: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateLogs: EventEmitter<any> = new EventEmitter<any>();
  @Output() attendence: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public _change: ChangeDetectorRef,
    public _utilityServices: UtilityService,
    public _userRoleService: UserRoleService
  ) { }

  ngOnInit() {
    // this.currentUser = JSON.parse(localStorage.currentUser);
    // this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.getRole()
    // if (this.user.isAdmin) this.isAdmin = true
    // if (this.user.isTrainer || this.user.isIQA || this.user.isMp) this.isStaff = true
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.group("ngOnChanges in attenadance-day")
    // console.log("Changes in attenadance-day", changes);

    if (changes.attendance && changes.attendance.currentValue) this.attendance = changes.attendance.currentValue
    // console.log(" attenadance-day this.attendance ", this.attendance)

    if (changes && changes.singleJob) this.jobData = changes.singleJob.currentValue
    // console.log(" JOB DATE IS HERE=> ", this.jobData)

    if (changes.hoverIndexValue && (changes.hoverIndexValue.currentValue != null || undefined)) this.hoverIndex = changes.hoverIndexValue.currentValue

    if (changes.countIndex && changes.countIndex.currentValue) this.count = changes.countIndex.currentValue;
    else this.hoverIndex = undefined;

    if (changes.selectedCourseMetaId && changes.selectedCourseMetaId.currentValue) {
      this.courseMetaId = changes.selectedCourseMetaId.currentValue
    }

    // console.groupEnd();
    // this._change.detectChanges();
  }

  ngAfterViewChecked() {
    if (this.count) {
      _.forEach(this.attendance, (singleLearner) => {
        singleLearner.attendance.splice(0, 10)
      });
      this._change.detectChanges();
    }
  }

  // UTILITY FUNCTION

  getRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }

  logToupdate(event) {
    console.group("logToupdate");
    console.log("event ==>", event);
    this.logUpdate.emit(event);
  }

  logsUpdate(event) {
    console.log("event 1");

    this.updateLogs.emit(event);
    console.log("array to be send from attendance-day-type", this.updateLogs);
  }
  attendenceUpdate(event) {
    console.log("event..............", event);
    this.attendence.emit({ attendence: event.attendance })
  }
  openModel(i, date) {
    console.log("what is the index value", i);
    let index
    if (this.jobData.scheduleDates == false)
      index = _.findIndex(this.attendance[0].jobDatesList.jobDatesList, (d) => { return d.date == date; })
    else
      index = i
    console.log("index---->", index);

    let data = this.attendance[0].jobDatesList.jobDatesList[index]
    console.log("what is the data to be send", data);

    data['courseMetaId'] = this.courseMetaId
    data['courseId'] = this.courseId
    data['register'] = true
    data['unitList'] = true
    data['jobId'] = this.jobData._id
    data['jobDatesList'] = this.attendance[0].jobDatesList.jobDatesList
    data['previousDate'] = date
    data['scheduleDates'] = this.jobData.scheduleDates
    data['isEdit'] = true
    data['userRole'] = this.isAdmin ? 'admin' : 'trainer'
    console.log("data pass in model", data);
    this._utilityServices.commonDialogBoxOpen(AllotmentConfirmationComponent, data)
      .afterClosed().subscribe(res => {
        console.log("updated data get", res);
        if (res == undefined) return
        else {
          if (res.deleted == true) {
            this.dateUpdate.emit(res.data)
            this._change.detectChanges()
            this._utilityServices.handleSnackBar({ msg: "Day remove successfully!", button: "Ok" })
          }
          else if (res.msg) {
            this._utilityServices.handleSnackBar({ msg: res.msg, button: "Ok" })
          }
          else {
            this.dateUpdate.emit(res.attendance)
            this._change.detectChanges()
            this._utilityServices.handleSnackBar({ msg: "Day updated successfully!", button: "Ok" })
          }
        }
      }, (error) => {
        console.log('edit time some error occure!!', error)
        this._utilityServices.handleSnackBar({ msg: "Something went wrong!", button: "Ok" })

      })
  }

}
